import { render, staticRenderFns } from "./PushConfiguration.vue?vue&type=template&id=f8caafc8&scoped=true"
import script from "./PushConfiguration.vue?vue&type=script&lang=js"
export * from "./PushConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PushConfiguration.vue?vue&type=style&index=0&id=f8caafc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8caafc8",
  null
  
)

export default component.exports